import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <div className="p-tabview-panels" data-pc-section="panelcontainer">
        <div
          id="pr_id_815_content"
          className="p-tabview-panel"
          role="tabpanel"
          aria-labelledby="pr_id_81_header_5"
          data-pc-name=""
          data-pc-section="content"
        >
          <div className="pl-2">
            <h2 className="font-serif-italic !text-[28px] pb-2 !leading-[26px]">
              Returns
            </h2>
            <div className="my-4">
              <div className="tab-content inline-block w-[calc(100%_-_270px)] 2xl_w-[calc(100%_-_350px)]">
                <div
                  className="pl-[26px] right-0 border-t border-siver-dark pt-5"
                  style={{ marginTop: 0 }}
                >
                  <div className="richContent-root-63a">
                    <p id="OGEXQAA">
                      You have the right to cancel your order made online or
                      over the telephone within a ‘cooling off’ period of 14
                      days from the day after you receive the goods. failblossom,
                      however, has extended this right to 30 days
                      from the date of receipt. This right applies to all items
                      except:
                    </p>
                    <ul>
                      <li>
                        Perishable goods and other items likely to expire
                        rapidly, this includes all flowers, fresh food, some
                        alcohol and beverages, and hampers and gift boxes
                        containing such items
                      </li>
                      <li>Jewellery for pierced ears</li>
                      <li>
                        Sealed items where the seal or cellophane has been
                        broken
                        <br />
                        Personalised or bespoke items
                      </li>
                      <li>
                        Items that cannot be returned for hygiene reasons such
                        as razors and brushes
                      </li>
                      <li>
                        Food items that have been purchased at a discount due to
                        a short shelf life
                      </li>
                      <li>
                        Fine wines which we store in a temperature-controlled
                        environment
                      </li>
                      <li>
                        Products sold with an authentication or valuation
                        certificate, where the certificate is not also returned;
                        and
                      </li>
                      <li>
                        Antique or vintage watches, jewellery, accessories or
                        homeware
                      </li>
                      <li>
                        Tea subscription refills and Lossus subscription refills
                        following the 1st month of the subscription period
                      </li>
                      <li>Discounted items</li>
                    </ul>

                    <p>&nbsp;</p>
                    <p>
                      You will be able to follow the instructions on the portal
                      on how to create your return label and return the goods to
                      us. Please note that the goods must be returned to us
                      within 14 days of notifying us of your return request.
                      Alternatively, the goods can be returned to our store at:
                      181 Piccadilly, London W1A 1ER.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      When the goods have been received and checked, a refund
                      (or an e-gift card) for the goods and the standard
                      delivery charge (premium charges are not refundable) will
                      be issued within 14 days. You may be contacted for details
                      as to how we can make repayment to you. Please note that
                      returning the goods to us is your responsibility and we
                      are not obliged to repay you for any costs that you have
                      incurred in returning the products to us.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      Your statutory rights are not affected.
                      <br />
                      &nbsp;
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Returns;
